(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aruva-block-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aruva-icons-text"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('tcc-icons-marquee')) {
		class TccIconsMarquee extends HTMLElement {
			connectedCallback() {
				this.track = this.querySelector('.tcc-it__track');
				this.group = this.querySelector('.tcc-it__group');
				if (!this.track || !this.group) return;

				this.speed = Math.max(parseFloat(this.dataset.speed) || 40, 1); // px per second
				this.distance = 0;
				this.hovered = false;
				this.inView = true;
				this.ready = false;

				this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
				this.onMotionChange = () => this.refresh();
				if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.onMotionChange);

				this.resizeObserver = new ResizeObserver(() => this.schedule());
				this.resizeObserver.observe(this);
				this.resizeObserver.observe(this.group);

				// Pause while off-screen (saves battery, no visual change)
				this.intersectionObserver = new IntersectionObserver((entries) => {
					this.inView = entries[0].isIntersecting;
					this.updatePlayState();
				});
				this.intersectionObserver.observe(this);

				if (this.dataset.pauseOnHover === 'true') {
					this.onEnter = () => { this.hovered = true; this.updatePlayState(); };
					this.onLeave = () => { this.hovered = false; this.updatePlayState(); };
					this.addEventListener('pointerenter', this.onEnter);
					this.addEventListener('pointerleave', this.onLeave);
				}

				// Start only once fonts are in, so the measured width is final and the loop never jumps.
				const start = () => {
					if (!this.isConnected) return;
					this.ready = true;
					this.refresh();
				};
				if (document.fonts && document.fonts.ready) {
					Promise.race([document.fonts.ready, new Promise((r) => setTimeout(r, 1500))]).then(start);
				} else {
					start();
				}
			}

			disconnectedCallback() {
				cancelAnimationFrame(this.raf);
				if (this.resizeObserver) this.resizeObserver.disconnect();
				if (this.intersectionObserver) this.intersectionObserver.disconnect();
				if (this.motionQuery && this.motionQuery.removeEventListener) {
					this.motionQuery.removeEventListener('change', this.onMotionChange);
				}
				if (this.onEnter) {
					this.removeEventListener('pointerenter', this.onEnter);
					this.removeEventListener('pointerleave', this.onLeave);
				}
				this.stop();
			}

			schedule() {
				if (!this.ready) return;
				cancelAnimationFrame(this.raf);
				this.raf = requestAnimationFrame(() => this.refresh());
			}

			isRtl() {
				const html = document.documentElement;
				return /^ar\b/i.test(html.lang || '') || html.dir === 'rtl';
			}

			fillWithClones(groupWidth) {
				const needed = Math.ceil(this.clientWidth / groupWidth) + 1;
				let count = this.track.children.length;
				while (count < needed) {
					const clone = this.group.cloneNode(true);
					clone.setAttribute('aria-hidden', 'true');
					clone.removeAttribute('role');
					clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
						el.removeAttribute('data-shopify-editor-block');
					});
					clone.querySelectorAll('[role="listitem"]').forEach((el) => el.removeAttribute('role'));
					this.track.appendChild(clone);
					count++;
				}
			}

			refresh() {
				if (!this.ready) return;

				if (this.motionQuery.matches) {
					this.stop();
					this.classList.add('is-static');
					return;
				}
				this.classList.remove('is-static');

				const distance = this.group.getBoundingClientRect().width;
				if (!distance) return;

				this.fillWithClones(distance);

				// Same set width → nothing to retime; just make sure play state is right.
				if (this.animation && Math.abs(distance - this.distance) < 0.5) {
					this.updatePlayState();
					return;
				}

				const duration = (distance / this.speed) * 1000;
				// English: right → left (0 → -distance). Arabic: left → right (-distance → 0).
				const keyframes = this.isRtl()
					? [{ transform: `translate3d(${-distance}px, 0, 0)` }, { transform: 'translate3d(0, 0, 0)' }]
					: [{ transform: 'translate3d(0, 0, 0)' }, { transform: `translate3d(${-distance}px, 0, 0)` }];

				if (this.animation) {
					// Keep the current position when the width changes, so there's no jump.
					const progress = this.animation.effect.getComputedTiming().progress || 0;
					this.animation.effect.setKeyframes(keyframes);
					this.animation.effect.updateTiming({ duration });
					this.animation.currentTime = progress * duration;
				} else {
					this.animation = this.track.animate(keyframes, {
						duration,
						iterations: Infinity,
						easing: 'linear',
					});
				}

				this.distance = distance;
				this.updatePlayState();
			}

			updatePlayState() {
				if (!this.animation) return;
				const shouldPlay = this.inView && !this.hovered;
				if (shouldPlay && this.animation.playState !== 'running') this.animation.play();
				if (!shouldPlay && this.animation.playState === 'running') this.animation.pause();
			}

			stop() {
				if (this.animation) this.animation.cancel();
				this.animation = null;
				this.distance = 0;
			}
		}

		customElements.define('tcc-icons-marquee', TccIconsMarquee);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aruva-science-v2"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('tcc-science-groups')) {
		/*
		 * Shared mobile slider (≤900px). Moves the track with transform: translate3d(±i * 100%),
		 * so it never depends on native scroll-snap (buggy in RTL on iOS Safari).
		 * LTR: next slide is to the right, track moves left.  RTL: next slide is to the left, track moves right.
		 */
		const TCC_ASV2_MQ = '(max-width: 900px)';

		const tccAsv2InitSlider = ({ root, viewport, track, slides, prev, next, dotsWrap, counter }) => {
			if (!root || !viewport || !track || !prev || !next || !dotsWrap) return null;
			dotsWrap.innerHTML = '';
			if (slides.length < 2) {
				root.classList.add('is-single');
				return null;
			}

			const mq = window.matchMedia(TCC_ASV2_MQ);
			let index = 0;
			let drag = null;
			let dots = [];

			const isRtl = () => getComputedStyle(track).direction === 'rtl';

			const render = (dragPx = 0) => {
				if (!mq.matches) {
					track.style.transform = '';
					return;
				}
				const sign = isRtl() ? 1 : -1;
				track.style.transform = `translate3d(calc(${sign * index * 100}% + ${dragPx}px), 0, 0)`;
			};

			const update = () => {
				dots.forEach((d, j) => {
					d.classList.toggle('is-active', j === index);
					d.setAttribute('aria-current', j === index ? 'true' : 'false');
				});
				prev.disabled = index === 0;
				next.disabled = index === slides.length - 1;
				if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
				slides.forEach((s, j) => s.setAttribute('aria-hidden', mq.matches && j !== index ? 'true' : 'false'));
			};

			const goTo = (i) => {
				index = Math.max(0, Math.min(slides.length - 1, i));
				track.classList.remove('is-dragging');
				render();
				update();
			};

			dots = slides.map((_, i) => {
				const dot = document.createElement('button');
				dot.type = 'button';
				dot.className = 'tcc-asv2-dot';
				dot.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
				dot.addEventListener('click', () => goTo(i));
				dotsWrap.appendChild(dot);
				return dot;
			});

			prev.addEventListener('click', () => goTo(index - 1));
			next.addEventListener('click', () => goTo(index + 1));

			/* ---------- Swipe ---------- */
			const onDown = (e) => {
				if (!mq.matches || (e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('button')) return;
				drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, t: performance.now(), active: false };
			};

			const onMove = (e) => {
				if (!drag || e.pointerId !== drag.id) return;
				const dx = e.clientX - drag.x;
				const dy = e.clientY - drag.y;

				if (!drag.active) {
					if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
					if (Math.abs(dy) > Math.abs(dx)) { drag = null; return; } // vertical scroll wins
					drag.active = true;
					drag.t = performance.now();
					try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
					track.classList.add('is-dragging');
				}

				const forward = isRtl() ? dx > 0 : dx < 0;
				const atEdge = (forward && index === slides.length - 1) || (!forward && index === 0);
				drag.dx = atEdge ? dx * 0.3 : dx;
				render(drag.dx);
			};

			const onEnd = (e) => {
				if (!drag || e.pointerId !== drag.id) return;
				const d = drag;
				drag = null;
				if (!d.active) return;

				const fast = Math.abs(d.dx) > 30 && performance.now() - d.t < 300;
				if (Math.abs(d.dx) > viewport.clientWidth * 0.2 || fast) {
					const forward = isRtl() ? d.dx > 0 : d.dx < 0;
					goTo(index + (forward ? 1 : -1));
				} else {
					goTo(index);
				}
			};

			viewport.addEventListener('pointerdown', onDown);
			viewport.addEventListener('pointermove', onMove);
			viewport.addEventListener('pointerup', onEnd);
			viewport.addEventListener('pointercancel', onEnd);

			const onMq = () => { render(); update(); };
			if (mq.addEventListener) mq.addEventListener('change', onMq);

			goTo(0);

			return {
				goTo,
				destroy() {
					if (mq.removeEventListener) mq.removeEventListener('change', onMq);
				},
			};
		};

		class TccScienceGroups extends HTMLElement {
			connectedCallback() {
				this.sliders = [];
				this.tabs = Array.from(this.querySelectorAll('.tcc-asv2-tab'));
				this.groups = Array.from(this.querySelectorAll('.tcc-asv2-group'));

				this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.activate(i)));

				this.groups.forEach((group) => {
					const track = group.querySelector('.tcc-asv2-stats');
					const slider = tccAsv2InitSlider({
						root: group.querySelector('.tcc-asv2-card'),
						viewport: group.querySelector('.tcc-asv2-slider'),
						track,
						slides: track ? Array.from(track.querySelectorAll('.tcc-asv2-stat')) : [],
						prev: group.querySelector('.tcc-asv2-arrow--prev'),
						next: group.querySelector('.tcc-asv2-arrow--next'),
						dotsWrap: group.querySelector('.tcc-asv2-dots'),
					});
					if (slider) this.sliders.push(slider);
				});

				// Theme Editor: selecting a Product Group block opens its tab
				this.onBlockSelect = (e) => {
					const i = this.groups.findIndex((g) => g.dataset.blockId === e.detail.blockId);
					if (i > -1) this.activate(i);
				};
				document.addEventListener('shopify:block:select', this.onBlockSelect);
			}

			disconnectedCallback() {
				document.removeEventListener('shopify:block:select', this.onBlockSelect);
				this.sliders.forEach((s) => s.destroy());
			}

			activate(index) {
				this.groups.forEach((g, i) => g.classList.toggle('is-active', i === index));
				this.tabs.forEach((t, i) => {
					t.classList.toggle('is-active', i === index);
					t.setAttribute('aria-pressed', String(i === index));
				});
			}
		}

		/* Used for both the Badges slider and the combined Credential + Logo slider */
		class TccAsv2BadgeSlider extends HTMLElement {
			connectedCallback() {
				const track = this.querySelector('.tcc-asv2-badges');
				this.slides = track ? Array.from(track.children) : [];
				this.slider = tccAsv2InitSlider({
					root: this,
					viewport: this.querySelector('.tcc-asv2-badges-viewport'),
					track,
					slides: this.slides,
					prev: this.querySelector('.tcc-asv2-arrow--prev'),
					next: this.querySelector('.tcc-asv2-arrow--next'),
					dotsWrap: this.querySelector(':scope > .tcc-asv2-dots'),
					counter: this.querySelector('.tcc-asv2-badges-counter'),
				});

				// Theme Editor: selecting a Badge / Credential / Logo block slides to it
				this.onBlockSelect = (e) => {
					const id = e.detail.blockId;
					const i = this.slides.findIndex((s) =>
						s.dataset.blockId === id || (s.dataset.blockIds || '').split(' ').includes(id)
					);
					if (i > -1 && this.slider) this.slider.goTo(i);
				};
				document.addEventListener('shopify:block:select', this.onBlockSelect);
			}

			disconnectedCallback() {
				document.removeEventListener('shopify:block:select', this.onBlockSelect);
				if (this.slider) this.slider.destroy();
			}
		}

		customElements.define('tcc-science-groups', TccScienceGroups);
		customElements.define('tcc-asv2-badge-slider', TccAsv2BadgeSlider);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-block-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cdk-block-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
